import { render } from "./WbOffer.vue?vue&type=template&id=6c62b4c6"
import script from "./WbOffer.vue?vue&type=script&lang=js"
export * from "./WbOffer.vue?vue&type=script&lang=js"

import "./WbOffer.vue?vue&type=style&index=0&id=6c62b4c6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__